import { useQuery, UseQueryResult } from 'react-query'
import { Clinic } from '@customTypes/Clinic'

import { getClinic } from 'src/services/api/clinic'

const useClinic: (clinicReferenceId: string) => UseQueryResult<Clinic> = (clinicReferenceId) =>
  useQuery(['clinic', clinicReferenceId], () => getClinic(clinicReferenceId), {
    enabled: !!clinicReferenceId,
  })

export default useClinic
